module.exports = __webpack_public_path__ + "img/9788954430449.5410abd4.jpg";